export const YoutubeIconFooter = () => (
  <svg
    width="25"
    height="18"
    viewBox="0 0 25 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.3015 7.10201C24.3015 6.5808 24.2147 5.97273 24.2147 5.27778C24.1278 4.58283 24.0409 3.88787 23.9541 3.27979C23.7803 2.58485 23.5197 2.06364 22.9985 1.6293C22.5641 1.19495 21.9561 0.934338 21.348 0.847469C19.35 0.586863 16.3965 0.5 12.4005 0.5C8.40457 0.5 5.36415 0.586863 3.45304 0.847469C2.84496 0.934338 2.23688 1.19495 1.80254 1.6293C1.3682 2.06364 1.02072 2.58485 0.846981 3.27979C0.673244 3.88787 0.586386 4.49596 0.586386 5.27778C0.499517 5.97273 0.499512 6.5808 0.499512 7.10201C0.499512 7.62322 0.499512 8.23131 0.499512 9.09999C0.499512 9.96868 0.499512 10.6636 0.499512 11.098C0.499512 11.6192 0.586386 12.2273 0.586386 12.9222C0.673254 13.6172 0.760112 14.3121 0.846981 14.9202C1.02072 15.6151 1.28133 16.1364 1.80254 16.5707C2.23688 17.005 2.84496 17.2656 3.45304 17.3525C5.45102 17.6131 8.40457 17.7 12.4005 17.7C16.3965 17.7 19.4369 17.6131 21.348 17.3525C21.9561 17.2656 22.5641 17.005 22.9985 16.5707C23.4328 16.1364 23.7803 15.6151 23.9541 14.9202C24.1278 14.3121 24.2147 13.704 24.2147 12.9222C24.3015 12.2273 24.3015 11.6192 24.3015 11.098C24.3015 10.5768 24.3015 9.96868 24.3015 9.09999C24.3015 8.23131 24.3015 7.53635 24.3015 7.10201ZM17.0046 9.79494L10.1419 14.0515C10.0551 14.1384 9.88133 14.2253 9.70759 14.2253C9.53386 14.2253 9.44699 14.2252 9.27325 14.1384C9.01265 13.9646 8.83891 13.704 8.83891 13.3566V4.75656C8.83891 4.40908 9.01265 4.14848 9.27325 3.97475C9.53386 3.80101 9.88133 3.80101 10.1419 3.97475L17.0046 8.23131C17.2652 8.40504 17.4389 8.66565 17.4389 8.92626C17.4389 9.18686 17.2652 9.62121 17.0046 9.79494Z"
      fill="white"
    />
  </svg>
);

export const FacebookIconFooter = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2495 0.5H2.74951C1.48389 0.5 0.499512 1.53125 0.499512 2.75V19.25C0.499512 20.5156 1.48389 21.5 2.74951 21.5H9.17139V14.375H6.21826V11H9.17139V8.46875C9.17139 5.5625 10.9058 3.92188 13.5308 3.92188C14.8433 3.92188 16.1558 4.15625 16.1558 4.15625V7.01562H14.7026C13.2495 7.01562 12.7808 7.90625 12.7808 8.84375V11H16.0151L15.4995 14.375H12.7808V21.5H19.2495C20.4683 21.5 21.4995 20.5156 21.4995 19.25V2.75C21.4995 1.53125 20.4683 0.5 19.2495 0.5Z"
      fill="white"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0154 4.57494C11.6187 4.50166 11.2543 4.75482 11.1788 5.14205C11.1033 5.52929 11.3573 5.90736 11.7432 5.98314C12.9051 6.20965 13.8022 7.10904 14.0296 8.2749V8.27573C14.0943 8.61134 14.3898 8.85534 14.73 8.85534C14.7757 8.85534 14.8213 8.85117 14.8678 8.84284C15.2537 8.7654 15.5077 8.38816 15.4322 8.00009C15.0927 6.25879 13.7524 4.91388 12.0154 4.57494Z"
      fill="white"
    />
    <path
      d="M11.9635 1.6733C11.7776 1.64665 11.5909 1.70161 11.4423 1.81986C11.2896 1.93978 11.1942 2.11299 11.1735 2.30703C11.1295 2.69926 11.4125 3.05401 11.8042 3.09815C14.5056 3.39961 16.6053 5.504 16.909 8.2138C16.9497 8.57689 17.2543 8.85087 17.6178 8.85087C17.6452 8.85087 17.6717 8.8492 17.6991 8.84587C17.8891 8.82505 18.0585 8.73095 18.178 8.58105C18.2966 8.43115 18.3506 8.24462 18.329 8.05391C17.9506 4.6729 15.3338 2.04887 11.9635 1.6733Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.19295 10.8103C12.5172 14.1336 13.2713 10.2889 15.3879 12.404C17.4284 14.444 18.6012 14.8527 16.0159 17.4373C15.692 17.6975 13.6345 20.8286 6.40367 13.5997C-0.828061 6.37 2.30116 4.31037 2.56148 3.98662C5.15306 1.39487 5.55472 2.57449 7.59525 4.61444C9.71181 6.73041 5.86872 7.48701 9.19295 10.8103Z"
      fill="white"
    />
  </svg>
);

export const BackIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="25" r="24.5" fill="white" stroke="#EFF0F7" />
    <path
      d="M29.5005 32.3125L21.2505 24.0625L29.5005 15.8125"
      stroke="#EA5023"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 3.62091C19.3106 3.62091 22.4231 4.90858 24.7641 7.24664C27.1051 9.58479 28.3943 12.6934 28.3943 16C28.3943 19.3066 27.1051 22.4153 24.7641 24.7534C22.4231 27.0915 19.3106 28.3791 16 28.3791C12.6893 28.3791 9.57677 27.0915 7.23578 24.7534C4.89485 22.4153 3.60559 19.3066 3.60559 16C3.60559 12.6934 4.89485 9.58474 7.23578 7.24664C9.57677 4.90858 12.6893 3.62091 16 3.62091ZM14.9954 19.974L21.922 13.0559C22.2056 12.7726 22.2056 12.3134 21.922 12.0301C21.6384 11.7469 21.1785 11.7469 20.8949 12.0301L14.4819 18.4354L11.106 15.0637C10.8224 14.7804 10.3625 14.7804 10.079 15.0637C9.79535 15.347 9.79535 15.8062 10.079 16.0894L13.9684 19.974C14.1102 20.1156 14.2961 20.1864 14.4819 20.1864C14.6677 20.1864 14.8536 20.1156 14.9954 19.974Z"
      fill="#7FCA64"
    />
  </svg>
);

export const TTLIcon = () => (
  <svg
    width="31"
    height="22"
    viewBox="0 0 31 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ttl-icon"
  >
    <g clipPath="url(#clip0)">
      <path
        className="ttl-icon__frame1"
        d="M6.17678 0L0 6.17678V6.93934L15.0607 22H15.8232L22.4957 15.3276V14.565L7.93068 0H6.17678Z"
        fill="#1999D6"
      />
      <path
        className="ttl-icon__frame2"
        d="M17.7297 0H9.18896L23.1058 13.9549H23.8683L27.3761 10.409V9.68458L17.7297 0Z"
        fill="#1DB0E2"
      />
      <path
        className="ttl-icon__frame3"
        d="M30.8839 6.17678L24.7071 0H18.9497L28.0242 9.0364H28.7487L30.8839 6.93934V6.17678Z"
        fill="#73C4E9"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="30.8839" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FBIcon = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    className="fb-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="fb-frame"
      d="M13.4361 0C5.9969 0 0 5.99864 0 13.44C0 20.122 4.93416 25.6651 11.3106 26.7281V17.3125H7.89465V13.44H11.3106V10.4786C11.3106 7.13763 13.2843 5.23932 16.3966 5.23932C17.8389 5.23932 19.433 5.46712 19.433 5.46712V8.80814H17.763C16.093 8.80814 15.5616 9.87119 15.5616 10.9342V13.44H19.2812L18.6739 17.3125H15.5616V26.7281C22.0139 25.741 26.8722 20.198 26.8722 13.44C26.8722 5.99864 20.8753 0 13.4361 0Z"
      fill="#4A50FF"
    />
  </svg>
);

export const YoutubeIcon = () => (
  <svg
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ytb-icon"
  >
    <path
      d="M13.962 0C6.52278 0 0.525879 5.99864 0.525879 13.44C0.525879 20.8814 6.52278 26.88 13.962 26.88C21.4012 26.88 27.3981 20.8814 27.3981 13.44C27.3981 5.99864 21.4012 0 13.962 0ZM21.1734 15.3383C21.1734 17.0847 19.7311 18.5275 17.9852 18.5275H9.71101C7.96508 18.5275 6.52278 17.0847 6.52278 15.3383V11.4658C6.52278 9.71932 7.96508 8.27661 9.71101 8.27661H17.9852C19.7311 8.27661 21.1734 9.71932 21.1734 11.4658V15.3383Z"
      fill="#EA5023"
      className="ytb-frame-1"
    />
    <path
      d="M16.1634 13.3639L12.6715 11.3897C12.5197 11.3137 12.0642 11.3897 12.0642 11.5415V15.2622C12.0642 15.4141 12.5197 15.5659 12.6715 15.49L16.3911 13.6676C16.467 13.6676 16.3152 13.4398 16.1634 13.3639Z"
      fill="#EA5023"
      className="ytb-frame-2"
    />
  </svg>
);

export const TiktokIcon = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="tiktok-icon"
  >
    <path
      d="M13.564 0C6.12483 0 0.12793 5.99864 0.12793 13.44C0.12793 20.8814 6.12483 26.88 13.564 26.88C21.0032 26.88 27.0001 20.8814 27.0001 13.44C27.0001 5.99864 21.0032 0 13.564 0ZM20.5478 11.9214C20.3959 11.9214 20.2441 11.9214 20.1682 11.9214C18.65 11.9214 17.2077 11.162 16.4486 9.87119V16.781C16.4486 19.5905 14.1713 21.8685 11.3626 21.8685C8.55396 21.8685 6.27666 19.5905 6.27666 16.781C6.27666 13.9715 8.55396 11.6936 11.3626 11.6936C11.4385 11.6936 11.5904 11.6936 11.6663 11.6936V14.1993C11.5904 14.1993 11.4385 14.1993 11.3626 14.1993C9.92034 14.1993 8.78169 15.3383 8.78169 16.781C8.78169 18.2237 9.92034 19.3627 11.3626 19.3627C12.8049 19.3627 14.0954 18.2237 14.0954 16.781V5.01153H16.5245C16.7523 7.13763 18.4982 8.88407 20.6237 9.03593V11.9214H20.5478Z"
      fill="#FF9D17"
      className="tiktok-frame"
    />
  </svg>
);

export const CallIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0151 5.15569C11.6184 5.08241 11.2541 5.33557 11.1786 5.7228C11.1031 6.11004 11.357 6.48811 11.7429 6.56389C12.9048 6.7904 13.802 7.68978 14.0294 8.85565V8.85648C14.0941 9.19209 14.3895 9.43608 14.7298 9.43608C14.7754 9.43608 14.8211 9.43192 14.8676 9.42359C15.2535 9.34615 15.5074 8.96891 15.4319 8.58084C15.0925 6.83953 13.7522 5.49463 12.0151 5.15569Z"
      fill="white"
    />
    <path
      d="M11.9633 2.25392C11.7774 2.22727 11.5907 2.28224 11.4421 2.40049C11.2894 2.52041 11.194 2.69362 11.1732 2.88765C11.1292 3.27988 11.4122 3.63464 11.8039 3.67878C14.5053 3.98024 16.605 6.08462 16.9088 8.79443C16.9494 9.15751 17.254 9.43149 17.6175 9.43149C17.6449 9.43149 17.6715 9.42983 17.6989 9.4265C17.8889 9.40568 18.0582 9.31158 18.1777 9.16168C18.2964 9.01178 18.3503 8.82524 18.3288 8.63454C17.9503 5.25353 15.3336 2.6295 11.9633 2.25392Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.1932 11.3909C12.5174 14.7142 13.2716 10.8695 15.3881 12.9846C17.4286 15.0245 18.6014 15.4332 16.0161 18.0178C15.6923 18.2781 13.6348 21.4091 6.40392 14.1803C-0.827817 6.95057 2.3014 4.89094 2.56172 4.56719C5.1533 1.97544 5.55497 3.15505 7.59549 5.19501C9.71205 7.31098 5.86896 8.06758 9.1932 11.3909Z"
      fill="white"
    />
  </svg>
);

export const HamburgerIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 7C3.44772 7 3 7.44772 3 8C3 8.55228 3.44772 9 4 9V7ZM28 9C28.5523 9 29 8.55228 29 8C29 7.44772 28.5523 7 28 7V9ZM4 9H28V7H4V9Z"
      fill="#333333"
    />
    <path
      d="M4 15C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17L4 15ZM28 17C28.5523 17 29 16.5523 29 16C29 15.4477 28.5523 15 28 15L28 17ZM4 17L28 17L28 15L4 15L4 17Z"
      fill="#333333"
    />
    <path
      d="M4 23C3.44772 23 3 23.4477 3 24C3 24.5523 3.44772 25 4 25L4 23ZM20 25C20.5523 25 21 24.5523 21 24C21 23.4477 20.5523 23 20 23L20 25ZM4 25L20 25L20 23L4 23L4 25Z"
      fill="#333333"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="close-icon"
  >
    <path
      d="M12.25 12.3936L29.75 29.8936"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="close-frame"
    />
    <path
      d="M29.75 12.3936L12.25 29.8936"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="close-frame"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.108 18.216C7.812 18.216 7.164 17.556 7.164 16.236V10.872H1.908C0.636 10.872 0 10.248 0 9C0 7.752 0.636 7.128 1.908 7.128H7.164V1.98C7.164 0.66 7.812 0 9.108 0C10.404 0 11.052 0.66 11.052 1.98V7.128H16.308C17.58 7.128 18.216 7.752 18.216 9C18.216 10.248 17.58 10.872 16.308 10.872H11.052V16.236C11.052 17.556 10.404 18.216 9.108 18.216Z"
      fill="#EA5023"
    />
  </svg>
);

export const SubIcon = () => (
  <svg
    width="13"
    height="4"
    viewBox="0 0 13 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.04 4C1.45333 4 0.96 3.81333 0.56 3.44C0.186667 3.04 0 2.56 0 2C0 1.41333 0.186667 0.933335 0.56 0.560001C0.96 0.186668 1.45333 0 2.04 0H10.56C11.12 0 11.5867 0.186668 11.96 0.560001C12.36 0.933335 12.56 1.41333 12.56 2C12.56 2.56 12.36 3.04 11.96 3.44C11.5867 3.81333 11.12 4 10.56 4H2.04Z"
      fill="#EA5023"
    />
  </svg>
);
